var _config = {
    hook: 'data-doubanid',
    hookMovieID: 'data-douban-movieid',
    flag: 'data-doubanrate',
    apiUrl: 'http://static.in.xl9.xunlei.com/movie/doubanScore/',
    template: function (data) {
        if (!data || !data.rating || !data.rating.average) {
            return '';
        }
        var ratingCoverage = DoubanRate.getRatingCoverage(data.rating.details);

        return '<div class="douban_box">\
        <div class="score_douban">\
            <div class="db_logo">豆<span class="logo_db"></span></div>\
            <div class="db_num">'+ (data.rating.average.toFixed(1) || 0) + '</div>\
        </div>\
        <div class="drop_db">\
            <h5>豆瓣评分</h5>\
            <dl class="score_des">\
                <dt class="drop_db_score">\
                    <span class="score_num">'+ (data.rating.average.toFixed(1) || 0) + '</span>\
                    <span class="score_star db_s_'+ (data.rating.stars || '00') + '"></span>\
                    <span class="score_user">'+ (data.rating.average ? ('<i>' + data.ratings_count + '</i>人评价') : ('评论人数不足')) + '</span>\
                </dt>\
                <dd>5星<span class="pro" style="width: '+ (ratingCoverage[5] || 0) + 'px;"></span><span class="per">' + (ratingCoverage[5] || '0') + '%</span></dd>\
                <dd>4星<span class="pro" style="width: '+ (ratingCoverage[4] || 0) + 'px;"></span><span class="per">' + (ratingCoverage[4] || '0') + '%</span></dd>\
                <dd>3星<span class="pro" style="width: '+ (ratingCoverage[3] || 0) + 'px;"></span><span class="per">' + (ratingCoverage[3] || '0') + '%</span></dd>\
                <dd>2星<span class="pro" style="width: '+ (ratingCoverage[2] || 0) + 'px;"></span><span class="per">' + (ratingCoverage[2] || '0') + '%</span></dd>\
                <dd>1星<span class="pro" style="width: '+ (ratingCoverage[1] || 0) + 'px;"></span><span class="per">' + (ratingCoverage[1] || '0') + '%</span></dd>\
            </dl>\
            <p class="txt_from"><span class="logo_db_s"></span>数据来源自豆瓣用户评分</p>\
            <span class="db_arrow">\
                <i class="ico_db_arw"></i>\
            </span>\
        </div>\
    </div>';
    }
};

function DoubanRate(doubanid, container, data) {
    this.doubanid = doubanid;
    this.container = container;
    this.data = data;
    // 初始化
    this.init();
}

DoubanRate.prototype.load = function () {
    var deferred = $.Deferred();

    $.ajax({
        url: _config.apiUrl + this.doubanid,
        dataType: 'jsonp',
        data: {
            _t: new Date().format('YYYYMMDDhh')
        },
        cache: true,
        timeout: 5000,
        jsonpCallback: 'doubanRate' + this.doubanid
    })
        .then(function (json) {
            if (json.errno) {
                deferred.reject(json);
            } else {
                deferred.resolve(json.score);
            }
        });

    return deferred;
}

DoubanRate.prototype.render = function (json) {
    $(this.container)
        .append(_config.template(json))
        .attr(_config.flag, true);
}

DoubanRate.prototype.init = function () {
    var self = this;
    if (this.data) {
        return this.render(this.data);
    }
    this.load()
        .then(function (json) {
            self.render(json);
        });
}

DoubanRate.renderAll = function () {
    var $eles = $('[' + _config.hook + ']').not('[' + _config.flag + '=true]');
    var $elesM = $('[' + _config.hookMovieID + ']').not('[' + _config.flag + '=true]');
    var movieIdArr = [];
    var movieIdStr = '';

    $eles.each(function () {
        var $ele = $(this);
        var doubanid = $ele.attr(_config.hook);
        if (doubanid) {
            new DoubanRate(doubanid, this);
        }
    });

    $elesM.each(function () {
        var $ele = $(this);
        var movieId = $ele.attr(_config.hookMovieID);
        if (movieId) {
            movieIdArr.push(movieId);
        }
    });

    movieIdStr = movieIdArr.join(',');

    if (movieIdStr) {
        DoubanRate.loadByMovieId(movieIdStr)
            .then(function (rates) {
                for (var movieid in rates) {
                    new DoubanRate(null, $('[' + _config.hookMovieID + '='+ movieid +']'), rates[movieid]);
                }
            })
    }
}

DoubanRate.loadByMovieId = function (movieid) {
    var deferred = $.Deferred();
    $.ajax({
        url: _config.apiUrl + '0/' + encodeURIComponent(movieid),
        dataType: 'jsonp',
        data: {
            _t: new Date().format('YYYYMMDDhh')
        },
        cache: true,
        timeout: 5000,
        jsonpCallback: 'doubanRate' + movieid.replace(/,/g, '')
    })
        .then(function (json) {
            if (json.errno) {
                deferred.reject(json);
            } else {
                deferred.resolve(json.score);
            }
        });

    return deferred;
}

DoubanRate.template = _config.template;

DoubanRate.config = function (obj) {
    for (var i in obj) {
        _config[i] = obj[i];
    };
}

DoubanRate.getRatingCoverage = function (detail) {
    var total = 0;
    var result = {};
    for (var i in detail) {
        total += detail[i];
    }
    for (var j in detail) {
        result[j] = ((detail[j] / (total || 1)) * 100).toFixed(1);
    }
    return result;
}

window.DoubanRate = DoubanRate;

module.exports = DoubanRate;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/douban_rate.js
// module id = 31
// module chunks = 2 10